module.exports = __webpack_public_path__ + "img/gear.516faa03.svg";